export default {
  data() {
    return {
      ENV: process.env.NODE_ENV,
    };
  },
};
